<template>
  <div style="overflow-x: hidden; overflow-y: auto; height: 100%;">
    <div class="page_header">
      <span class="page_title">车辆运行分析报告</span>
      <div style="flex:1;text-align: right;">
        <quickQuery :isDownload="true" @handleQuery="onQuery" @quickQuery="onQuery" style="text-align: right"
          :isNow="true" @download="generatePdf" />
      </div>
    </div>
    <el-divider></el-divider>

    <div  v-loading="isLoading" >
       
      <div id="pdf-content" class="pdf-content">
        <!-- 报告标题 -->
        <Header :companyName="companyName" />

        <VehicleBasicInfo :basicInfo="reportData.basicInfo" :fuelType="fuelType" :reportTime="reportTime" />

        <VehicleRunInfo :vehicleStatus="reportData.vehicleStatus" :fuelType="fuelType" :beginDate="beginDate"
          :endDate="endDate" />
        <VehicleWorkInfo :speedChart="reportData.speedChart" :engineRevChart="reportData.engineRevChart"
          :engineLoadChart="reportData.engineLoadChart" :basicInfo="reportData.basicInfo" :fuelType="fuelType"
          :motorRevChart="reportData.motorRevChart" :speedEngineRevChart="reportData.speedEngineRevChart"
          :waterTempChart="reportData.waterTempChart" :socChart="reportData.socChart"
          :motorTempChart="reportData.motorTempChart" :batteryCurChart="reportData.batteryCurChart"
          :motorLoadChart="reportData.motorLoadChart" :engineRevStallChart="reportData.engineRevStallChart" />
        <div class="no-page-break-before"></div>

        <VehicleReportData style="padding-top: 10px;" :vehicleStatus="reportData.vehicleStatus" :fuelType="fuelType"
          :engineLoadChart="reportData.engineLoadChart" :basicInfo="reportData.basicInfo"
          :oilPressChart="reportData.oilPressChart" :gasTempChart="reportData.gasTempChart"
          :voltageChart="reportData.voltageChart" />


      </div>
    </div>
    <!-- <div v-else style="text-align: center; padding: 20px;font-size: 20px;">
      运行分析报告
    </div> -->

  </div>
</template>

<script>
// import * as echarts from 'echarts'
import Header from './header.vue'
import VehicleBasicInfo from './vehicle_basicinfo.vue'
import quickQuery from '../components/generalOrQuickQuery.vue'
import html2pdf from 'html2pdf.js'
import VehicleRunInfo from './vehicle_runinfo.vue'
import VehicleWorkInfo from './vehicle_workinfo.vue'
import VehicleReportData from './vehicle_report_data.vue'
import { queryOperationAnalysisReport } from '@/http/vehicle'
import { mapState } from "vuex";
export default {
  name: 'VehicleReport',
  components: {
    Header,
    VehicleBasicInfo,
    VehicleRunInfo,
    VehicleWorkInfo,
    VehicleReportData,
    quickQuery
  },
  computed: {
    ...mapState({
      //   opened: state => state.app.sidebar.opened,
      selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
      size: (state) => state.app.size,
    }),
    companyName() {
      return this.$store.state.user.operator.ComName;
      // return this.$store.state.userInfo.companyName
    }
  },
  data() {
    return {
      currentDate: '',
      showData: false,
      isLoading: false,
      isExporting: false,
      searchForm: {
        vehiclePlate: '',
        dateRange: []
      },

      fuelType: 2,//1是电车， 2是油车
      reportTime: '',//报告生成时间
      beginDate: '2026-01-01',//报告开始时间
      endDate: '2026-01-01',//报告结束时间
      reportData: {
        basicInfo: undefined,//基础信息
        vehicleStatus: undefined,
        speedChart: [],
        engineRevChart: [],
        engineLoadChart: {
          Chart: [],
          PieChart: []
        },
        engineRevStallChart: {
          Stall: [],
          Load: []
        },
        speedEngineRevChart: undefined,
        waterTempChart: undefined,
        socChart: undefined,
        motorTempChart: undefined,
        batteryCurChart: undefined,
        motorRevChart: undefined,
        motorLoadChart: undefined,
        oilPressChart: undefined,
        gasTempChart: undefined,
        voltageChart: undefined,//名称要改动

      },

    }
  },
  mounted() {
    // 初始化日期
    this.currentDate = new Date().toLocaleDateString()
    // 加载默认数据
    // this.loadReportData()
  },
  methods: {
    onQuery(val) {
      this.reportTime = new Date().toLocaleString()
      this.loadReportData(val)
    },
    // 加载报告数据
    loadReportData(dates) {
      //先选择车辆
      if (this.selectedVehicles.length == 0) {
        this.$message.warning(this.$t("vehicletrack.selectvehicle"));
        return;
      }
      if (this.selectedVehicles.length > 1) {
        this.$message.warning(this.$t("vehicletrack.selectmorevehicle"));
        return;
      }
      this.showData = true;
      // 替换为实际的车辆ID
      // query.VehicleID = this.selectedVehicles[0].VehicleID;
      if (this.selectedVehicles[0].oilTypeID_New == 5) {
        this.fuelType = 1;//新能源
      } else {
        this.fuelType = 2;
      }
      this.beginDate = dates.beginDate;
      this.endDate = dates.endDate;
      var query = {
        "BeginTime": dates.beginDate + " 00:00:00",
        "EndTime": dates.endDate + " 23:59:59",
        "VehicleID": this.selectedVehicles[0].nodeValue,
        "FuelType": this.fuelType
      };




      this.isLoading = true;
      // 模拟API调用，实际项目中应该替换为真实的API请求
      // 这里使用模拟数据填充报告
      //  this.fuelType=1;

      // this.fuelType=2;
      // query = {
      //   "BeginTime": "2025-12-01 00:00:00",
      //   "EndTime": "2025-12-09 00:00:00",
      //   "VehicleID": 67890,
      //   "FuelType": this.fuelType
      // };
      queryOperationAnalysisReport(query).then(res => {
        if (res.code === 200) {
          this.reportData = res.data
        }
      }).catch(() => {
        this.$message.error('报告数据加载失败');
      }).finally(() => {
        this.isLoading = false;
      })

    },



    // 生成PDF
    async generatePdf() {
      // 检查是否有数据
      if (!this.reportData || !this.reportData.basicInfo) {
        this.$message.warning('请先查询报告数据');
        return;
      }
      if (this.isExporting) return;
      this.isExporting = true;

      const loading = this.$loading({
        lock: true,
        text: '正在生成PDF，请稍候...',
        background: 'rgba(255, 255, 255, 0.6)'
      });

      // 获取要转换为PDF的元素
      const element = document.getElementById('pdf-content');

      // 收集 #pdf-content 内所有 echarts 实例：关闭动画并强制 resize，
      // 确保 html2canvas 截图时图表已完整渲染，避免出现空白/残缺/动画未完成
      const chartEls = Array.from(element.querySelectorAll('.chart-container'));
      const charts = [];
      chartEls.forEach(el => {
        const inst = echarts.getInstanceByDom(el);
        if (inst) charts.push(inst);
      });
      charts.forEach(c => {
        c.setOption({ animation: false });
        c.resize();
      });

      try {
        // 等待 DOM 更新与图表渲染完成
        await this.$nextTick();
        await new Promise(resolve => setTimeout(resolve, 400));

        const d = new Date();
        const dateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

        // 配置选项
        const opt = {
          margin: 6,
          filename: `车辆运行报告_${this.reportData.basicInfo.CarNo || '未知'}_${dateStr}.pdf`,
          image: { type: 'png' },
          html2canvas: {
            scale: 2, // 提高分辨率
            useCORS: true,
            logging: false,
            backgroundColor: '#ffffff'
          },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
          pagebreak: {
            // css: 遵循 CSS page-break 规则; legacy: 兼容算法处理其余分页
            mode: ['css', 'legacy'],
            avoid: ['.speed-data-section', '.chart-container', '.note-section', '.avoid-page-break']
          }
        };

        // 生成PDF
        await html2pdf().from(element).set(opt).save();
        this.$message.success('PDF生成成功');
      } catch (err) {
        console.error('PDF生成失败', err);
        this.$message.error('PDF生成失败，请重试');
      } finally {
        // 恢复图表动画
        charts.forEach(c => {
          try { c.setOption({ animation: true }); } catch (e) { /* ignore */ }
        });
        loading.close();
        this.isExporting = false;
      }
    },
  },
  beforeDestroy() {


  }
}
</script>

<style scoped>
.pdf-generator {
  padding: 20px;
}

.report-controls {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 5px;
}

.search-form {
  display: flex;
  align-items: center;
}

.search-form .el-form-item {
  margin-right: 15px;
}

.pdf-content {
  width: 210mm;
  /*   A4宽度
    width: 800px; */
  /* A4宽度 */
  margin: 0 auto;
  padding: 12mm;
  background-color: white;

}


.report-meta {
  color: #666;
  font-size: 14px;
}

.report-meta span {
  margin: 0 15px;
}

/* 章节样式 */
/* PDF分页控制样式 */
.report-section {
  margin-bottom: 40px;
  page-break-inside: avoid;
  /* 尽量避免在章节内分页 */
}

::v-deep .no-page-break-before {
  page-break-before: avoid;
  padding-top: 10px;
}

.no-page-break-after {
  page-break-after: avoid;
}

.avoid-page-break {
  page-break-inside: avoid;
}

/* PDF 分页优化：穿透到子组件，保证“图表+表格+说明”整体不被截断 */
::v-deep .speed-data-section,
::v-deep .chart-container,
::v-deep .note-section,
::v-deep .avoid-page-break {
  page-break-inside: avoid;
  break-inside: avoid;
}

.data-grid,
.chart-container {
  page-break-inside: avoid;
  /* 避免在数据网格和图表中间分页 */
}

/* 调整章节间距，使PDF分页更合理 */
.report-section {
  margin-top: 30px;
  margin-bottom: 30px;
}

.report-section h2 {
  color: #337ab7;
  font-size: 20px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
}

.report-section h3 {
  color: #555;
  font-size: 16px;
  margin: 20px 0 10px 0;
}

/* 车辆信息样式 */
.vehicle-info {

  border-radius: 5px;
}

.info-row {
  display: flex;
  margin-bottom: 15px;
}

.info-item {
  flex: 1;
  display: flex;
  align-items: center;
}

.info-item label {
  font-weight: bold;
  color: #555;
  margin-right: 10px;
  min-width: 80px;
}

.info-item .active {
  color: #52c41a;
  font-weight: bold;
}

/* 汇总数据样式 */
.summary-data {
  margin-top: 20px;
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.data-card {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  border: 1px solid #e8e8e8;
}

.data-value {
  font-size: 24px;
  font-weight: bold;
  color: #337ab7;
  margin-bottom: 8px;
}

.data-label {
  font-size: 14px;
  color: #666;
}

/* 表格样式 */
.alarm-table,
.behavior-table,
.overspeed-table,
.chart-table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
}

.alarm-table th,
.alarm-table td,
.behavior-table th,
.behavior-table td,
.overspeed-table th,
.overspeed-table td,
.chart-table th,
.chart-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

.alarm-table th,
.behavior-table th,
.overspeed-table th,
.chart-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  color: #333;
}

.alarm-table tr:nth-child(even),
.behavior-table tr:nth-child(even),
.overspeed-table tr:nth-child(even),
.chart-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

/* 图表容器样式 */
.chart-container {
  margin: 20px 0;
}

.chart {
  width: 100%;
  height: 400px;
}

.chart-data {
  margin-top: 20px;
}

/* 评估样式 */
.evaluation {
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 5px;
}

.evaluation-score {
  text-align: center;
  margin-bottom: 20px;
}

.score-value {
  font-size: 48px;
  font-weight: bold;
  color: #337ab7;
  line-height: 1;
}

.score-label {
  font-size: 16px;
  color: #666;
  margin-top: 5px;
}

.evaluation-level {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.evaluation-content {
  text-align: left;
}

.evaluation-content p {
  line-height: 1.6;
  color: #555;
  margin-bottom: 15px;
}

.evaluation-content ul {
  padding-left: 20px;
  margin-bottom: 15px;
}

.evaluation-content li {
  margin-bottom: 8px;
  line-height: 1.5;
  color: #555;
}

/* 页脚样式 */
.footer {
  margin-top: 50px;
  padding-top: 20px;
  border-top: 1px solid #ddd;
  text-align: center;
  font-size: 14px;
  color: #999;
}

/* 按钮样式 */
.generate-btn {
  margin: 20px 0;
  padding: 10px 20px;
  background-color: #337ab7;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.generate-btn:hover {
  background-color: #286090;
}

::v-deep .el-table .el-table__cell {
  padding: 4px 0;
  border-bottom: 1px solid #A3C0E8 !important;
  border-right: 1px solid #A3C0E8 !important
}

::v-deep .el-table {
  border: 1px solid #A3C0E8 !important;
}

::v-deep .table-caption {
  text-align: center;
  margin: 8px 0;
  font-weight: 500;
}

::v-deep .el-table .cell {
  padding: 2px 0 !important;
  font-size: 8pt !important;
  line-height: 16px !important;

}

::v-deep .generate-time {

  color: #333;
}

::v-deep .cell-header {
  background: #E2F0FF !important;
  color: #000 !important;
  border-bottom: 1px solid #A3C0E8 !important;
  border-right: 1px solid #A3C0E8 !important;
}

::v-deep .cell-header-warning {
  background: #FF8040 !important;
  color: #000 !important;
  border-bottom: 1px solid #A3C0E8 !important;
  border-right: 1px solid #A3C0E8 !important;
}

::v-deep .cell-header-success {
  background: #0FB513 !important;
  color: #000 !important;
  border-bottom: 1px solid #A3C0E8 !important;
  border-right: 1px solid #A3C0E8 !important;
}

::v-deep .el-table th {
  background: #E2F0FF !important;
  color: #000 !important;
}

::v-deep .chart-container {
  width: 100%;
  background: #f9fafc;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}
</style>